<template>
  <div class="text-field">
    <div class="text-field__input">
      <input :id="id" :type="type" class="form-control text-field__control" :placeholder="placeholder" :value="value" @input="inputHandler">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  methods: {
    inputHandler(ev) {
      this.$emit('input', { name: this.name, value: ev.target.value })
    }
  }
}
</script>
